import React, { Component } from 'react'
import styles from './style.styl'

const DEFAULT_ICON_SRC = require('images/svg/lightning-navy.svg')

export default class EventCard extends Component {
  static defaultProps = {
    iconSrc: DEFAULT_ICON_SRC
  }

  renderTimelineEventIcon = () => (
    <img className="timelineEventIcon" src={this.props.iconSrc}/>
  )

  render() {
    const { isNote } = this.props
    const noteClass = isNote ? 'note' : ''
    return (
      <div className="flex-start">
        <div className={`${styles.TypeIcon} flex-center`}>
          {this.renderTimelineEventIcon()}
        </div>
        <div className={`${styles.Card} ${noteClass}`}>
          {this.props.children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/EventCard/index.js